var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.559,
    height: 16.559,
    viewBox: "0 0 16.559 16.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.626,0H4.933A4.939,4.939,0,0,0,0,4.933v6.693a4.939,4.939,0,0,0,4.933,4.933h6.693a4.939,4.939,0,0,0,4.933-4.933V4.933A4.939,4.939,0,0,0,11.626,0Zm3.267,11.626a3.267,3.267,0,0,1-3.267,3.267H4.933a3.267,3.267,0,0,1-3.267-3.267V4.933A3.267,3.267,0,0,1,4.933,1.666h6.693a3.267,3.267,0,0,1,3.267,3.267v6.693Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.283,133a4.283,4.283,0,1,0,4.283,4.283A4.288,4.288,0,0,0,137.283,133Zm0,6.9a2.617,2.617,0,1,1,2.617-2.617A2.617,2.617,0,0,1,137.283,139.9Z",
    transform: "translate(-129.003 -129.003)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.026,
    cy: 1.026,
    r: 1.026,
    transform: "translate(11.544 3.003)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e329616786c774249b3a5632a1767cd4.svg";
export { ForwardRef as ReactComponent };